import React from "react";

const ProductOverviewTab = ({ productOverview }) => {
  const reportDetails =
    (productOverview?.reportDetails.length > 0 &&
      productOverview?.reportDetails[0]) ||
    false;
  return (
    <div className="flex-1 overflow-y-auto p-6">
      <div className="w-full">
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Product Overview
          </h2>

          <div className="space-y-6 pl-2">
            {/* Basic Information - 3 columns */}
            <div className="grid grid-cols-3 gap-6">
              <div>
                <p className="text-sm text-gray-500 mb-2">Product Name</p>
                <p className="text-base font-medium text-gray-900">
                  {productOverview.productName}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-2">Product Code</p>
                <p className="text-base text-gray-900">
                  {productOverview.productCode}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-2">Product Owner</p>
                <p className="text-base text-gray-900">
                  {productOverview.productOwner}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-2">Parent Domain</p>
                <p className="text-base text-gray-900">
                  {productOverview.parentDomainName}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-2">Domain</p>
                <p className="text-base text-gray-900">
                  {productOverview.domainName}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-2">Sub Domain</p>
                <p className="text-base text-gray-900">
                  {productOverview.subDomainName}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-2">Data Layer</p>
                <p className="text-base text-gray-900">
                  {productOverview.dataLayer.charAt(0).toUpperCase() +
                    productOverview.dataLayer.slice(1)}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-2">Status</p>
                <p className="text-base text-gray-900">
                  {productOverview.status}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-2">Documentation URL</p>

                {productOverview.productDocumentationUrl &&
                productOverview.productDocumentationUrl !== "N/A" ? (
                  <a
                    href={productOverview.productDocumentationUrl}
                    target="_blank"
                    rel="noopener noreferrer "
                    className="text-base cursor-pointer text-blue-300 pr-[10px]"
                  >
                    Document Url
                  </a>
                ) : (
                  <p className="text-base text-gray-900">
                    {productOverview.productDocumentationUrl || "N/A"}
                  </p>
                )}
              </div>
            </div>

            <div className="border-t border-gray-200 pt-6">
              <p className="text-sm text-gray-500 mb-2">Description</p>
              <p className="text-base text-gray-900">
                {productOverview.description}
              </p>
            </div>

            <div>
              <p className="text-sm text-gray-500 mb-2">Product Tags</p>
              <div className="flex flex-wrap gap-2">
                {Array.isArray(productOverview.productTag) &&
                productOverview.productTag.length > 0 ? (
                  productOverview.productTag.map((tag, index) => {
                    const tagColors = [
                      "bg-blue-100 text-blue-800",
                      "bg-green-100 text-green-800",
                      "bg-purple-100 text-purple-800",
                      "bg-yellow-100 text-yellow-800",
                      "bg-red-100 text-red-800",
                      "bg-indigo-100 text-indigo-800",
                    ];
                    return (
                      <span
                        key={index}
                        className={`px-2 py-1 rounded-full text-xs font-medium ${
                          tagColors[index % tagColors.length]
                        }`}
                      >
                        {tag}
                      </span>
                    );
                  })
                ) : (
                  <p className="text-base text-gray-900">N/A</p>
                )}
              </div>
            </div>

            {/* Market Information */}
            <div className="border-t border-gray-200 pt-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Market Information
              </h3>
              <div className="grid grid-cols-3 gap-6 pl-2">
                <div>
                  <p className="text-sm text-gray-500 mb-2">Parent Region</p>
                  <p className="text-base text-gray-900">
                    {productOverview.parentRegion || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-2">Market Region</p>
                  <p className="text-base text-gray-900">
                    {Array.isArray(productOverview.marketRegion) &&
                    productOverview.marketRegion.length > 0
                      ? productOverview.marketRegion.join(", ")
                      : "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-2">Market Country</p>
                  <p className="text-base text-gray-900">
                    {Array.isArray(productOverview.marketCountry) &&
                    productOverview.marketCountry.length > 0
                      ? productOverview.marketCountry.join(", ")
                      : "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-2">Line of Business</p>
                  <p className="text-base text-gray-900">
                    {(() => {
                      const lob = productOverview.lineOfBusiness?.toLowerCase();
                      if (lob === "mw") return "MW";
                      if (lob === "health") return "Health and Wellness";
                      if (lob === "immersive") return "Immersive Experience";
                      return productOverview.lineOfBusiness || "N/A";
                    })()}
                  </p>
                </div>
              </div>
            </div>

            {/* Additional Information */}
            <div className="border-t border-gray-200 pt-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Additional Information
              </h3>
              <div className="grid grid-cols-3 gap-6 pl-2">
                <div>
                  <p className="text-sm text-gray-500 mb-2">
                    Min Expected Users
                  </p>
                  <p className="text-base text-gray-900">
                    {productOverview.minExpectedUsers}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-2">
                    Max Expected Users
                  </p>
                  <p className="text-base text-gray-900">
                    {productOverview.maxExpectedUsers}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-2">Asset Source</p>
                  <div className="flex flex-wrap gap-2">
                    {(() => {
                      const sources = Array.isArray(productOverview.assetSource)
                        ? productOverview.assetSource
                        : productOverview.assetSource
                        ? [productOverview.assetSource]
                        : [];

                      if (sources.length === 0) {
                        return <p className="text-base text-gray-900">N/A</p>;
                      }

                      const formatSource = (source) => {
                        const s = source?.toLowerCase();
                        if (s === "uc") return "UC";
                        if (s === "adls") return "ADLS";
                        if (s === "manual") return "Manual";
                        return source;
                      };

                      const tagColors = [
                        "bg-emerald-100 text-emerald-800",
                        "bg-cyan-100 text-cyan-800",
                        "bg-orange-100 text-orange-800",
                      ];

                      return sources.map((source, index) => (
                        <span
                          key={index}
                          className={`px-2 py-1 rounded-full text-xs font-medium ${
                            tagColors[index % tagColors.length]
                          }`}
                        >
                          {formatSource(source)}
                        </span>
                      ));
                    })()}
                  </div>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-2">Size Threshold</p>
                  <p className="text-base text-gray-900">
                    {productOverview.sizeThreshold
                      ? `${productOverview.sizeThreshold.value || ""} ${
                          productOverview.sizeThreshold.unit || ""
                        }`.trim() || "N/A"
                      : "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-2">Value Mapping</p>
                  <p className="text-base text-gray-900">
                    {productOverview.valueMapping}
                  </p>
                </div>
              </div>
            </div>
            {reportDetails && (
              <div className="border-t border-gray-200 pt-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Report Details
                </h3>

                {/* Top grid */}
                <div className="grid grid-cols-3 gap-6">
                  <div>
                    <p className="text-sm text-gray-500 mb-2">Report Type</p>
                    <p className="text-base text-gray-900">
                      {reportDetails.reportType || "N/A"}
                    </p>
                  </div>

                  <div>
                    <p className="text-sm text-gray-500 mb-2">Report Owner</p>
                    <p className="text-base text-gray-900">
                      {reportDetails.reportOwner || "N/A"}
                    </p>
                  </div>

                  <div>
                    <p className="text-sm text-gray-500 mb-2">Report Link</p>
                    {reportDetails.reportLink ? (
                      <a
                        href={reportDetails.reportLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 underline"
                      >
                        View Report
                      </a>
                    ) : (
                      <p className="text-base text-gray-900">N/A</p>
                    )}
                  </div>
                </div>

                {/* Report Objective */}
                <div className="mt-6">
                  <p className="text-sm text-gray-500 mb-2">Report Objective</p>
                  <p className="text-base text-gray-900">
                    {reportDetails.reportObjective || "N/A"}
                  </p>
                </div>

                {/* Key Decision Support */}
                <div className="mt-6">
                  <p className="text-sm text-gray-500 mb-2">
                    Key Decision Support
                  </p>
                  {reportDetails.keyDecisionSupport ? (
                    <ul className="list-disc list-outside pl-5 text-base text-gray-900 space-y-1">
                      {reportDetails.keyDecisionSupport
                        .split("\n")
                        .map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                    </ul>
                  ) : (
                    <p className="text-base text-gray-900">N/A</p>
                  )}
                </div>

                {/* Report Sections */}
                <div className="mt-6">
                  <p className="text-sm text-gray-500 mb-2">Report Sections</p>
                  <div className="flex flex-wrap gap-2">
                    {reportDetails.reportSection ? (
                      reportDetails.reportSection
                        .split(",")
                        .map((section, index) => {
                          const tagColors = [
                            "bg-blue-100 text-blue-800",
                            "bg-green-100 text-green-800",
                            "bg-purple-100 text-purple-800",
                            "bg-yellow-100 text-yellow-800",
                            "bg-indigo-100 text-indigo-800",
                          ];

                          return (
                            <span
                              key={index}
                              className={`px-3 py-1 rounded-full text-xs font-medium ${
                                tagColors[index % tagColors.length]
                              }`}
                            >
                              {section.trim()}
                            </span>
                          );
                        })
                    ) : (
                      <p className="text-base text-gray-900">N/A</p>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductOverviewTab;
